import dayjs from "@lib/dayjs";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { IMessageJobMembersProfile } from "@endpoints/types/message.type";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { EnumUserTypes } from "@utils/constants";

type JobMembersCardProps = {
  item: IMessageJobMembersProfile;
  selectedContact: any;
  handleContactSelect: (user: any) => void;
};

const JobMembersCard = (props: JobMembersCardProps) => {
  const navigate = useNavigate();
  const { item, selectedContact, handleContactSelect } = props;
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("jobId");
  // const { jobId } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const [expandCard, setExpandCard] = useState(false);

  const isReferral = user.userType === EnumUserTypes.REFERRAL_AMBASSADOR;

  const latestJob = item.appliedJobs.reduce((latest, job) => {
    if (!job.lastMessageCreatedAt) return latest;

    return !latest ||
      dayjs(job.lastMessageCreatedAt).isAfter(
        dayjs(latest.lastMessageCreatedAt)
      )
      ? job
      : latest;
  }, null);

  const handleJobClick = (party, job) => {
    navigate(
      `/messages?jobId=${
        isReferral ||
        party.userDetails.userType === EnumUserTypes.REFERRAL_AMBASSADOR
          ? job.job._id
          : job.jobApplicationId
      }`,
      {
        state: party,
      }
    );
  };

  const isSelected =
    selectedContact?.userDetails?._id === item?.userDetails?._id;

  // Card will expand and show the applied jobs on first load
  useEffect(() => {
    if (item?.appliedJobs?.some((aJ) => aJ?.jobApplicationId === jobId)) {
      setExpandCard(true);
    } else {
      setExpandCard(false);
    }
  }, [jobId]);

  return (
    <div className="flex flex-col border-b border-[#bababa]">
      <div
        className={`flex justify-between py-3 px-4 cursor-pointer hover:bg-gray-50 ${
          isSelected ? "bg-[#F1F5F9]" : ""
        }`}
        // key={item?.appliedJobs[0]?.lastMessage||index}
        onClick={() => setExpandCard((prev) => !prev)}
      >
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full self-start flex bg-[#E1E0E0] bg-nwhited shadow-sm">
            {item?.userDetails?.profilePic ? (
              <img
                src={item?.userDetails?.profilePic}
                className="h-full w-full object-cover rounded-full"
                alt="profileImg"
              />
            ) : (
              <div className="font-montserrat text-white font-semibold uppercase w-10 h-10 rounded-full bg-gray-400 flex items-center justify-center text-xl">
                {item?.userDetails?.firstName?.charAt(0)}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-1 text-xs">
            <p className="text-primary font-bold">
              {item?.userDetails.firstName} {item?.userDetails.lastName}
            </p>
            <p className="text-light-black font-medium">
              {item?.userDetails.companyName}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-end justify-between text-[11px]">
          <p className="text-light-black font-medium">
            {item?.userDetails.refNo}
          </p>
          {item?.userDetails.unseenMessagesCount > 0 && (
            <div className="text-[10px] font-medium bg-[#0C9D44] text-white rounded-full h-4 w-4 text-center">
              {item?.userDetails.unseenMessagesCount}
            </div>
          )}
        </div>
      </div>
      {/* Applied jobs */}
      {expandCard ? (
        <div className="flex flex-col">
          {item?.appliedJobs?.map((appliedJob, aIndex) => {
            return (
              <div
                key={appliedJob?.jobApplicationId}
                onClick={() => {
                  handleContactSelect(item);
                  handleJobClick(item, appliedJob);
                }}
                className={`py-2 hover:bg-gray-50 cursor-pointer  ${
                  aIndex !== 0 ? "border-t" : ""
                }`}
              >
                <div className={`flex flex-col border-l ml-8 px-3 py-1 gap-1`}>
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-xs text-primary">
                      {appliedJob?.job?.title}
                    </span>
                    {appliedJob?.unseenMessagesCount > 0 ? (
                      <div className="text-[10px] font-medium bg-[#BABABA] text-white rounded-full h-4 w-4 text-center">
                        {appliedJob?.unseenMessagesCount}
                      </div>
                    ) : null}
                  </div>
                  <span className="font-medium text-light-black text-xs">
                    {appliedJob?.lastMessage}
                  </span>
                  <span className=" text-gray-400 text-xs italic">
                    {dayjs(appliedJob?.lastMessageCreatedAt).format(
                      "hh:mm a, DD/mm/YYYY"
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default JobMembersCard;
